'use client';

import { Root } from '@radix-ui/react-label';

import type { ComponentProps, JSX } from 'react';

import { cn } from '~/utils';

export function Label({
  className,
  ...props
}: ComponentProps<typeof Root>): JSX.Element {
  return (
    <Root
      data-slot='label'
      className={cn(
        'flex items-center gap-2 text-(length:--text-sm) leading-[130%] font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50',
        className,
      )}
      {...props}
    />
  );
}
